/**
 * This file is auto-generated from ChatProfileDataRequest.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const profileTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Just a moment';
        case 'pl':
            return 'Jeszcze chwila';
    }
};

export const profileSubtitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'To process your subscription, we need your personal information.';
        case 'pl':
            return 'Aby zrealizować subskrypcję, potrzebujemy Twoich danych osobowych.';
    }
};

export const saveError: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Your data was saved, but something went wrong. Please try again.';
        case 'pl':
            return 'Twoje dane zostały zapisane, ale coś poszło nie tak. Spróbuj ponownie.';
    }
};
